import React, { FC } from 'react';

import { useWorkTypesQuery } from 'Dictionary/query/dictionaryQuery';
import { FormikAutocompleteField } from 'components/FormikField/FormikAutocompleteField/FormikAutocompleteField';

export interface WorkTypeSelectFieldProps {
  name: string;
  disabled?: boolean;
}

export const WorkTypeSelectField: FC<
  WorkTypeSelectFieldProps
> = ({
  name,
  disabled = false,
}) => {
  const { data = [], isLoading, refetch } = useWorkTypesQuery();

  return (
    <FormikAutocompleteField
      name={name}
      label="Work type"
      disabled={disabled}
      options={data}
      loading={isLoading}
      onOpen={() => refetch()}
      multiple
    />
  );
};
